import { render, staticRenderFns } from "./FileSvg.vue?vue&type=template&id=1c878e95&scoped=true&"
import script from "./FileSvg.vue?vue&type=script&lang=js&"
export * from "./FileSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c878e95",
  null
  
)

export default component.exports